import { db } from "@/lib/dexie/dexieDB";
import { tryCatch } from "@/lib/try-catch";
import type { CalendarView } from "@/components/calendar/event-calendar/types";

// Preference keys
export const PREFERENCE_KEYS = {
  CALENDAR_VIEW: "calendarView",
} as const;

// Get a preference value
export async function getPreference<T>(key: string): Promise<T | undefined> {
  const { data: entry, error } = await tryCatch(db.preferences.get(key));

  if (error) {
    console.error("Error reading preference from IndexedDB:", error);
    return undefined;
  }

  return entry ? (entry.value as T) : undefined;
}

// Set a preference value
export async function setPreference<T>(key: string, value: T): Promise<boolean> {
  const { error } = await tryCatch(
    db.preferences.put({
      key,
      value,
    }),
  );

  if (error) {
    console.error("Error writing preference to IndexedDB:", error);
    return false;
  }

  return true;
}

// Specific calendar view functions
export async function getCalendarView(): Promise<CalendarView | undefined> {
  return getPreference<CalendarView>(PREFERENCE_KEYS.CALENDAR_VIEW);
}

export async function setCalendarView(view: CalendarView): Promise<boolean> {
  return setPreference(PREFERENCE_KEYS.CALENDAR_VIEW, view);
}
